<script>
    import { Card, CardBody, CardHeader, CardFooter, Table, Spinner, Pagination, PaginationLink, PaginationItem} from 'sveltestrap';
    import { selectedGroup } from '../../store';
    import Search from '../../components/Search.svelte';
    import http from '../../api/http.js';
    import TableColumn from '../../components/TableColumn.svelte';

    export let computerId;
    let previousPageNumber = 0;
    let totalServicesCount = 0;
    let errorMessage = "";
    let isLoading = false;
    let searchRefresh = false;
    let inputLength = 0
    let searchTerm = "";
    let pageNumber = 1;
    let totalPageCount = 0;
    const displayNumbers = [10, 25, 50, 100, 200];
    let displayNumber = displayNumbers[0];
    let services = [];
    let sortType = {
      ascending: 'ascending',
      descending: 'descending',
      resting: 'resting'
    }
    let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };

    function toggleSort(columnValue, theSortType){
        if(activeColumn.value != columnValue){
        activeColumn.columnValue = columnValue;    
        }
        switch(theSortType){
        case sortType.resting:      
            activeColumn.sortType = sortType.ascending;      
            break;
        case sortType.ascending:
            activeColumn.sortType = sortType.descending;
            break;
        case sortType.descending:
            activeColumn.sortType = sortType.ascending;
            break;
        }
        
        if(activeColumn.sortType != sortType.resting){
        loadServices(columnValue, activeColumn.sortType);
        }
        else{
        activeColumn.columnValue = 0;
        activeColumn.sortType = sortType.ascending;
        loadServices(0, activeColumn.sortType);
        }
    }

    $: {    
        $selectedGroup;
        if ($selectedGroup != undefined){
            pageNumber = 1;
            loadServices();
        }  
        }

    $:activeColumn;

    $:{
        pageNumber;
        displayNumber;
        loadServices(activeColumn.columnValue, activeColumn.sortType);
    }

    $: {
        if (previousPageNumber != pageNumber) {
        previousPageNumber = pageNumber;
        }
    }

    function setPageNumber(number){
        pageNumber = number;    
    }

    async function searchServices(){ 
        searchRefresh = true;
        let interval = setInterval( async () => {
        if(searchTerm.length != inputLength){
            pageNumber = 1;
            loadServices(activeColumn.columnValue, activeColumn.sortType);   
        }
        if(!searchRefresh){
            clearInterval(interval);
        }
        inputLength = searchTerm.length;  
        }, 2000);    
    }

    async function loadServices(columnValue, sortTypeArg){
        if(!isLoading){
            let ascending = sortTypeArg == sortType.ascending ? true : false;
            errorMessage = "";
            let url = "";
            if(columnValue == undefined){
                columnValue = 0;
            }
            if(ascending == undefined){
                ascending = true;
            }
            isLoading = true;
            if(searchTerm.length > 0 && searchTerm != ""){
                url = `/deploy/dashboard/computers/services/${$selectedGroup}/${computerId}/${searchTerm}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}`;
            }
            else{
                url = `/deploy/dashboard/computers/services/${$selectedGroup}/${computerId}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}`;
            }
            const res = await http.get(window.apiBaseUrl + url);
            if(res.status == 200){
                let uiServiceCollection = await res.json();
                services = uiServiceCollection.services;
                totalPageCount = uiServiceCollection.totalPageCount;
                totalServicesCount = uiServiceCollection.noPaginationServiceCount;
                isLoading = false;
            }
            else if(res.status == 404){
                isLoading = false;
                services = [];
            }
            else{
                errorMessage = "Something went wrong, please try again.";
                isLoading = false;
                services = [];
            }
        }
    }
    const interval = setInterval(loadServices(activeColumn.columnValue, activeColumn.sortType), 30000);
</script>
{#await loadServices(activeColumn.columnValue, activeColumn.sortType)}
    <Spinner color="primary" type="border"></Spinner>
{:then}
<Card>
    <CardHeader>
        <div class="row">
            <div class="col-sm">
                <h6 class="font-weight-bold mt-2 mb-2">Services</h6>
            </div>
            <div class="col-sm">
                <Search id="services-search-input" bind:searchTerm placeholder="Search Services..." on:input={() => searchServices()}></Search>   
             </div>
             <div class="col-sm"> 
             </div>
        </div>        
    </CardHeader>
    <CardBody>
        <Table responsive>
            <thead>     
                <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Name</TableColumn>
                <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Start Type</TableColumn>
                <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>Status</TableColumn>
            </thead>
            <tbody>
                {#if services.length > 0}
                    {#each services as service}
                        <tr id="software-row-{service.id}">
                            <td>{service.name}</td>
                            <td>{service.startType}</td>
                            <td>{service.status}</td>                            
                        </tr>            
                    {/each}
                {:else}
                    <tr>
                        <td colspan="3" class="text-center">No Services Found</td>
                    </tr>
                {/if}
            </tbody>
        </Table>
    </CardBody>
  <CardFooter>
    <div class="pagination bg-light shadow-none ml-0 d-flex">
        {#if services.length == 0}
          <small class="mt-3 mr-auto">0 - 0 of 0 services</small>
        {:else}
          <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalServicesCount ? totalServicesCount:pageNumber * displayNumber)} of {totalServicesCount} services</small>
        {/if}      
        
        <div class="mt-2 justify-content-center">
           <Pagination>
              <PaginationItem disabled={pageNumber == 1}>
                <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
              </PaginationItem>
  
              <PaginationItem  disabled={pageNumber == 1}>
                <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
              </PaginationItem>
  
              {#if totalPageCount > 5}
                {#each Array(5) as _, count}
                  {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                    <PaginationItem active={pageNumber == count + pageNumber} >
                      <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                    </PaginationItem>
                  {:else if pageNumber <= 3}
                    <PaginationItem active={pageNumber == count + 1} >
                      <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                    </PaginationItem>
                  {:else if pageNumber >= totalPageCount - 2}
                    <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                      <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                    </PaginationItem>
                  {/if}
                {/each}
              {:else}
                {#each Array(totalPageCount) as _, count}
                  <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {/each}
              {/if}      
  
              <PaginationItem disabled={pageNumber == totalPageCount}>
                <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
              </PaginationItem>
              
              <PaginationItem disabled={pageNumber == totalPageCount}>
                <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
              </PaginationItem>
            </Pagination>
        </div>
        <div class="mt-3 ml-auto">
          <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
            {#each displayNumbers as displayNumber}
              <option value={displayNumber}>{displayNumber}</option>
            {/each}
          </select>
          <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
        </div>  
      </div>
</CardFooter>
</Card>
    
{/await}

  <style>

  </style>